<template lang="pug">
  #Profile
    #header_back(@click.stop.prevent="routerBack()")
      i.custom.icon-icon_arrowLeft.position-absolute
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 個人資料
    .container-width
      .pt-3.px-4.text-center.mb-5(
          v-if="profile"
        )
        .mb-3
          ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
            :profileUrl="profileImgUrl",
            :style="{ 'width': '100px', 'height': '100px' }",
            :changeProfile="true",
            @changeProfileImgHandler="changeProfileImgHandler"
          )
          input.d-none(
            type="file",
            accept="image/*",
            id="imageUpload",
            @change="fileUploadHandler()",
            ref="imageUploadInput"
          )
        p.text-center 請顧問上傳形象照
        .input_wrap.input_wrap-name
          input.profile_name(
            type='text',
            name='profile_name'
            v-model='preferred_name',
          )
          .profile_name_icon(
            @click.stop.prevent='changeProfilePreferredNameHandler()'
          )
            i.fas.fa-pencil-alt
        .input_wrap.input_wrap-switch.my-3
          .profile_switch_wrap
            .profile_switch_text
              span  非上班時段預設回覆訊息
            .profile_switch(:class="{ 'active': is_auto_reply}" @click.stop.prevent='SwitchAutoReplyHandler')
              .profile_switch_btn
          textarea.mt-2#profile_message(name='profile_message' cols='30' rows='8', v-model="message")
        .row.justify-content-center.align-items-center.h-100
          .col-6
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="saveHandler()",
              style="border: 4px solid #000;border-radius: 50px;padding: 0px 15px;box-shadow: 0.2rem 0.2rem 0 #00000033;",
            ) 確定

    .container-bottom
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'ProfileIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      preferred_name: null,
      is_auto_reply: false,
      message: '',
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sa_profile/getProfileHandler')
      .then(() => {
        vm.$swal.close();
        vm.preferred_name = vm.profile.preferred_name;
        vm.is_auto_reply = vm.profile.non_work_reply_status;
        vm.message = vm.profile.non_work_reply_message;
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    changeProfileImgHandler() {
      this.$refs.imageUploadInput.click();
    },
    fileUploadHandler() {
      const vm = this;
      const obj = vm.$refs.imageUploadInput;
      if (!obj.files[0]) return;

      vm.$swal.fire({
        title: '上傳中',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      const file = obj.files[0];
      const formData = new FormData();
      formData.append('file', file);

      vm.$store.dispatch('sa_profile/changeProfilePictureHandler', formData)
        .then(() => {
          obj.value = null;
          vm.$swal.close();
        });
    },
    routerBack() {
      this.$router.back();
    },
    SwitchAutoReplyHandler() {
      const vm = this;
      if (vm.is_auto_reply) {
        vm.is_auto_reply = false;
      } else {
        vm.is_auto_reply = true;
      }
      vm.saveHandler();
    },
    changeProfilePreferredNameHandler() {
      const vm = this;

      if (vm.preferred_name === '' || vm.preferred_name === null) {
        vm.$swal.fire({
          icon: 'info',
          title: '請輸入顧問名'
        });
        return;
      }

      vm.$swal.fire({
        title: '更新顧問名，請稍等',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      const formData = {
        name: vm.preferred_name
      };
      vm.$store.dispatch('sa_profile/changeProfilePreferredNameHandler', formData)
        .then(() => {
          vm.$swal.close();
        });
    },
    saveHandler() {
      const vm = this;
      const status = vm.is_auto_reply === true ? '1' : '0';
      let formData = {
        status: status,
        message: vm.message
      }
      vm.$store.dispatch('sa_profile/changeProfileAutoReplyMessageHandler', formData)
        .then(() => {
          vm.$swal.close();
        });
    }
  },
  computed: {
    ...mapState({
      profile: (state) => state.sa_profile.data,
      profileImgUrl: (state) => state.sa_profile.profileImgUrl
    })
  }
};
</script>

<style scoped>
  @font-face {
    font-family: "icon";
    src: url("../../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  #header_back {
    font-size: 1.7rem;
    padding: 0.5rem;
    position: absolute;
    top: 3%;
    left: 1.6rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: #fff !important;
    z-index: 15;
  }
  i.custom {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .icon-icon_arrowLeft {
    top: 0;
    left: 5px;
  }
  .icon-icon_arrowLeft:before {
    content: "\e907";
  }
  .icon-icon_edit:before {
    content: "\e911";
  }
  .profile_name {
    font-size: 1.2rem;
    text-align: center;
    font-weight: 600;
    padding-right: 8rem;
    padding-left: 8rem;
  }
  .input_wrap {
    position: relative;
  }
  input[type="text"], input[type="date"], select, textarea {
    border: 0;
    outline: 0;
    background-color: #eee;
    font-size: 1rem;
    padding: 0.6rem 1rem;
    border-radius: 9487px;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .profile_name_icon {
    position: absolute;
    top: 50%;
    right: 1rem;
    font-size: 1.3rem;
    transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
  }
  .profile_switch_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .profile_switch {
    width: 2.5rem;
    height: 1.5rem;
    background-color: #eee;
    border-radius: 9487px;
    padding: 0.5rem 0;
    cursor: pointer;
    position: relative;
  }
  .profile_switch.active .profile_switch_btn {
    background-color: #ef4852;
    left: calc(100% - 1.3rem);
  }
  .profile_switch_btn {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    background-color: #aaa;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    position: absolute;
    top: 50%;
    left: 0.2rem;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
  }
  textarea {
    border-radius: 1rem;
    resize: none;
  }

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}
.container-bottom {
  padding-bottom: 50px;
}
</style>
